import type { ICsvCellViewData } from "./csv-list.models";

export const buildCsvCellViewData = ({
  displayValues,
  numberOfItemsToShow,
  showHiddenItemsAsEllipsis,
  tooltipPrefix,
}: {
  displayValues: string[];
  numberOfItemsToShow?: number;
  showHiddenItemsAsEllipsis?: boolean;
  tooltipPrefix: string;
}): ICsvCellViewData => {
  const allValuesJoined = displayValues.join(", ");
  const tooltipContent = `${tooltipPrefix} ${allValuesJoined}`;

  if (!numberOfItemsToShow || displayValues.length <= numberOfItemsToShow) {
    return { displayValue: allValuesJoined, moreItemsCount: 0, tooltipContent };
  }

  const shownValuesJoined = displayValues
    .slice(0, numberOfItemsToShow)
    .join(", ");

  if (showHiddenItemsAsEllipsis) {
    return {
      displayValue: `${shownValuesJoined}...`,
      moreItemsCount: 0,
      tooltipContent,
    };
  }

  return {
    displayValue: shownValuesJoined,
    moreItemsCount: displayValues.length - numberOfItemsToShow,
    tooltipContent,
  };
};
